<template>
  <div class="hero-split-outer">
    <section
      class="hero-centered"
      :class="{
        'hero-centered--iata': isIata,
        'hero-centered--airlines': isAirlines,
        'hero-centered--home': !isIata && !isAirlines,
      }"
    >
      <div v-if="!isIata && !isAirlines" ref="flowDots" class="hc-flow-dots" aria-hidden="true">
        <span v-for="dot in 6" :key="dot" class="hc-flow-dot" />
      </div>
      <div v-if="!isAirlines" class="hc-al-wrap" aria-hidden="true">
        <div
          v-for="(airline, index) in heroAirlines"
          :key="airline.name"
          class="hc-al"
          :class="`hc-al--${index + 1}`"
        >
          <img :src="airline.logo" :alt="airline.name" />
        </div>
      </div>

      <div class="hc-body">
        <h1 class="hero-split__title">{{ hero.title }}</h1>
        <p class="hero-split__sub">{{ hero.subtitle }}</p>
        <p class="hero-split__desc">
          <strong v-if="hero.descriptionLead" class="hero-split__desc-lead">
            {{ hero.descriptionLead }}
          </strong>
          {{ hero.description }}
        </p>
        <div class="hero-split__ctas">
          <a
            class="nav-bar__demo"
            :data-tf-popup="dynamicDemoUrl"
            :data-tf-iframe-props="`title=${hero.ctaLabel}`"
            @click="tryClick"
          >
            {{ hero.ctaLabel }}
          </a>
        </div>
      </div>

      <div v-if="!isIata" class="hc-chips" aria-hidden="true">
        <div
          v-if="isAirlines || airlineSellerSlots.iataAgencies <= 3"
          class="hc-chip"
          :class="`hc-chip--${airlineSellerSlots.iataAgencies}`"
        >
          <span class="hc-chip__icon">
            <svg width="14" height="14" viewBox="0 0 256 256" fill="#2a8aea">
              <path
                d="M128,24h0A104,104,0,1,0,232,128,104.12,104.12,0,0,0,128,24Zm88,104a87.61,87.61,0,0,1-3.33,24H174.16a157.44,157.44,0,0,0,0-48h38.51A87.61,87.61,0,0,1,216,128ZM102,168H154a115.11,115.11,0,0,1-26,45A115.27,115.27,0,0,1,102,168Zm-3.9-16a140.84,140.84,0,0,1,0-48h59.88a140.84,140.84,0,0,1,0,48ZM40,128a87.61,87.61,0,0,1,3.33-24H81.84a157.44,157.44,0,0,0,0,48H43.33A87.61,87.61,0,0,1,40,128ZM154,88H102a115.11,115.11,0,0,1,26-45A115.27,115.27,0,0,1,154,88Zm52.33,0H170.71a135.28,135.28,0,0,0-22.3-45.6A88.29,88.29,0,0,1,206.37,88ZM107.59,42.4A135.28,135.28,0,0,0,85.29,88H49.63A88.29,88.29,0,0,1,107.59,42.4ZM49.63,168H85.29a135.28,135.28,0,0,0,22.3,45.6A88.29,88.29,0,0,1,49.63,168Zm98.78,45.6a135.28,135.28,0,0,0,22.3-45.6h35.66A88.29,88.29,0,0,1,148.41,213.6Z"
              />
            </svg>
          </span>
          <span>{{ $t('home.hero.chipIataAgencies') }}</span>
        </div>
        <div
          v-if="isAirlines || airlineSellerSlots.ota <= 3"
          class="hc-chip"
          :class="`hc-chip--${airlineSellerSlots.ota}`"
        >
          <span class="hc-chip__icon">
            <svg width="14" height="14" viewBox="0 0 256 256" fill="#2a8aea">
              <path
                d="M43.18,128a29.78,29.78,0,0,1,8,10.26c4.8,9.9,4.8,22,4.8,33.74,0,24.31,1,36,24,36a8,8,0,0,1,0,16c-17.48,0-29.32-6.14-35.2-18.26-4.8-9.9-4.8-22-4.8-33.74,0-24.31-1-36-24-36a8,8,0,0,1,0-16c23,0,24-11.69,24-36,0-11.72,0-23.84,4.8-33.74C50.68,38.14,62.52,32,80,32a8,8,0,0,1,0,16C57,48,56,59.69,56,84c0,11.72,0,23.84-4.8,33.74A29.78,29.78,0,0,1,43.18,128ZM240,120c-23,0-24-11.69-24-36,0-11.72,0-23.84-4.8-33.74C205.32,38.14,193.48,32,176,32a8,8,0,0,0,0,16c23,0,24,11.69,24,36,0,11.72,0,23.84,4.8,33.74a29.78,29.78,0,0,0,8,10.26,29.78,29.78,0,0,0-8,10.26c-4.8,9.9-4.8,22-4.8,33.74,0,24.31-1,36-24,36a8,8,0,0,0,0,16c17.48,0,29.32-6.14,35.2-18.26,4.8-9.9,4.8-22,4.8-33.74,0-24.31,1-36,24-36a8,8,0,0,0,0-16Z"
              />
            </svg>
          </span>
          <span>{{ $t('home.hero.chipOta') }}</span>
        </div>
        <div
          v-if="isAirlines || airlineSellerSlots.nonIataAgencies <= 3"
          class="hc-chip"
          :class="`hc-chip--${airlineSellerSlots.nonIataAgencies}`"
        >
          <span class="hc-chip__icon">
            <svg width="14" height="14" viewBox="0 0 256 256" fill="#2a8aea">
              <path
                d="M128,24a104,104,0,0,0,0,208,8,8,0,0,0,5-14.23h0c-1.12-.91-20.88-17.32-31.06-49.77h26a8,8,0,0,0,0-16H98.08a140.17,140.17,0,0,1,0-48h59.88A138,138,0,0,1,160,128a8,8,0,0,0,16,0,154.7,154.7,0,0,0-1.84-24h38.51A87.61,87.61,0,0,1,216,128a8,8,0,0,0,16,0A104.11,104.11,0,0,0,128,24ZM107.59,42.4A135.28,135.28,0,0,0,85.29,88H49.63A88.29,88.29,0,0,1,107.59,42.4Zm0,171.2a88.29,88.29,0,0,1-58-45.6H85.29A135.28,135.28,0,0,0,107.59,213.6ZM81.84,152H43.33a88.15,88.15,0,0,1,0-48H81.84a157.44,157.44,0,0,0,0,48ZM102,88a115.11,115.11,0,0,1,26-45,115.27,115.27,0,0,1,26,45Zm68.75,0a135.28,135.28,0,0,0-22.3-45.6,88.29,88.29,0,0,1,58,45.6Zm50.95,85.66L203.31,192l18.35,18.34a8,8,0,0,1-11.32,11.32L192,203.31l-18.34,18.35a8,8,0,0,1-11.32-11.32L180.69,192l-18.35-18.34a8,8,0,0,1,11.32-11.32L192,180.69l18.34-18.35a8,8,0,0,1,11.32,11.32Z"
              />
            </svg>
          </span>
          <span>{{ $t('home.hero.chipNonIataAgencies') }}</span>
        </div>
        <div
          v-if="isAirlines || airlineSellerSlots.tmc <= 3"
          class="hc-chip"
          :class="`hc-chip--${airlineSellerSlots.tmc}`"
        >
          <span class="hc-chip__icon">
            <svg width="14" height="14" viewBox="0 0 256 256" fill="#2a8aea">
              <path
                d="M216,56H176V48a24,24,0,0,0-24-24H104A24,24,0,0,0,80,48v8H40A16,16,0,0,0,24,72V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V72A16,16,0,0,0,216,56ZM96,48a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8v8H96ZM216,72v41.61A184,184,0,0,1,128,136a184.07,184.07,0,0,1-88-22.38V72Zm0,128H40V131.64A200.19,200.19,0,0,0,128,152a200.25,200.25,0,0,0,88-20.37V200ZM104,112a8,8,0,0,1,8-8h32a8,8,0,0,1,0,16H112A8,8,0,0,1,104,112Z"
              />
            </svg>
          </span>
          <span>{{ $t('home.hero.chipTmc') }}</span>
        </div>
        <div
          v-if="isAirlines || airlineSellerSlots.superApps <= 3"
          class="hc-chip"
          :class="`hc-chip--${airlineSellerSlots.superApps}`"
        >
          <span class="hc-chip__icon">
            <svg width="14" height="14" viewBox="0 0 256 256" fill="#2a8aea">
              <path
                d="M197.58,129.06,146,110l-19-51.62a15.92,15.92,0,0,0-29.88,0L78,110l-51.62,19a15.92,15.92,0,0,0,0,29.88L78,178l19,51.62a15.92,15.92,0,0,0,29.88,0L146,178l51.62-19a15.92,15.92,0,0,0,0-29.88ZM137,164.22a8,8,0,0,0-4.74,4.74L112,223.85,91.78,169A8,8,0,0,0,87,164.22L32.15,144,87,123.78A8,8,0,0,0,91.78,119L112,64.15,132.22,119a8,8,0,0,0,4.74,4.74L191.85,144ZM144,40a8,8,0,0,1,8-8h16V16a8,8,0,0,1,16,0V32h16a8,8,0,0,1,0,16H184V64a8,8,0,0,1-16,0V48H152A8,8,0,0,1,144,40ZM248,88a8,8,0,0,1-8,8h-8v8a8,8,0,0,1-16,0V96h-8a8,8,0,0,1,0-16h8V72a8,8,0,0,1,16,0v8h8A8,8,0,0,1,248,88Z"
              />
            </svg>
          </span>
          <span>{{ $t('home.hero.chipSuperApps') }}</span>
        </div>
        <div
          v-if="isAirlines || airlineSellerSlots.travelTechStartups <= 3"
          class="hc-chip"
          :class="`hc-chip--${airlineSellerSlots.travelTechStartups}`"
        >
          <span class="hc-chip__icon">
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#2a8aea"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="m5 5 7 8 7-8" />
              <path d="M12 13v6" />
            </svg>
          </span>
          <span>{{ $t('home.hero.chipTravelTechStartups') }}</span>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { createHeroFlowDots } from './heroFlowDots.js';
import { AmplitudeEvent } from 'components/shared/amplitude.js';
import lufthansaLogo from '../images/landing/network/Lufthansa.svg';
import britishAirwaysLogo from '../images/landing/network/british-airways.svg';
import emiratesLogo from '../images/landing/network/Emirates.svg';
import lotLogo from '../images/landing/network/lot-polish-airlines.svg';
import iberiaLogo from '../images/landing/network/Iberia.svg';
import flydubaiLogo from '../images/landing/network/flydubai.svg';

const HERO_AIRLINES = [
  { name: 'Lufthansa', logo: lufthansaLogo },
  { name: 'British Airways', logo: britishAirwaysLogo },
  { name: 'Emirates', logo: emiratesLogo },
  { name: 'LOT', logo: lotLogo },
  { name: 'Iberia', logo: iberiaLogo },
  { name: 'Fly Dubai', logo: flydubaiLogo },
];

const AIRLINE_SELLER_IDS = [
  'iataAgencies',
  'ota',
  'nonIataAgencies',
  'tmc',
  'superApps',
  'travelTechStartups',
];

const shuffled = (items) => {
  const result = [...items];

  for (let index = result.length - 1; index > 0; index -= 1) {
    const randomIndex = Math.floor(Math.random() * (index + 1));
    [result[index], result[randomIndex]] = [result[randomIndex], result[index]];
  }

  return result;
};

const shuffledSlots = (items) =>
  shuffled(items).reduce((slots, item, index) => {
    slots[item] = index + 1;
    return slots;
  }, {});

export default {
  props: {
    variant: {
      type: String,
      default: 'default',
    },
    heroContent: {
      type: Object,
      default: null,
    },
    trackingSpot: {
      type: String,
      default: 'hero',
    },
  },
  data() {
    return {
      heroAirlines: shuffled(HERO_AIRLINES),
      airlineSellerSlots: shuffledSlots(AIRLINE_SELLER_IDS),
      heroIsVisible: true,
      heroMotionObserver: null,
      heroMotionPaused: false,
      heroPageIsActive: true,
      heroMotionScrollTimer: null,
      heroMotionScrollHandler: null,
      heroDotMotion: null,
      heroMotionQuery: null,
      heroDotResizeObserver: null,
      heroDotResizeTimer: null,
    };
  },
  computed: {
    isIata() {
      return this.variant === 'iata';
    },
    isAirlines() {
      return this.variant === 'airlines';
    },
    hero() {
      return (
        this.heroContent || {
          title: this.$t('home.hero.title'),
          subtitle: this.$t('home.hero.subtitle'),
          description: this.$t('home.hero.description'),
          ctaLabel: this.$t('home.hero.ctaLabel'),
        }
      );
    },
    dynamicDemoUrl() {
      if (this.$i18n.locale == 'pl') {
        return 'iBhXNckk';
      } else {
        return 'CctmLklr';
      }
    },
  },
  mounted() {
    this.heroMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.heroMotionQuery.addEventListener?.('change', this.handleHeroMotionPreferenceChange);

    this.heroPageIsActive = !document.hidden;
    document.addEventListener('visibilitychange', this.handleHeroVisibilityChange);
    window.addEventListener('pagehide', this.handleHeroPagePause);
    window.addEventListener('pageshow', this.handleHeroPageResume);
    window.addEventListener('drct:extension-transition', this.syncHeroMotion);

    if (window.IntersectionObserver) {
      this.heroMotionObserver = new IntersectionObserver(
        ([entry]) => {
          this.heroIsVisible = entry?.isIntersecting ?? true;
          this.syncHeroMotion();
        },
        { rootMargin: '0px' }
      );
      this.heroMotionObserver.observe(this.$el);
    } else {
      this.heroMotionScrollHandler = () => {
        if (this.heroMotionScrollTimer) return;
        this.heroMotionScrollTimer = window.setTimeout(() => {
          this.heroMotionScrollTimer = null;
          const rect = this.$el.getBoundingClientRect();
          this.heroIsVisible = rect.bottom >= 0 && rect.top <= window.innerHeight;
          this.syncHeroMotion();
        }, 80);
      };
      window.addEventListener('scroll', this.heroMotionScrollHandler, { passive: true });
      window.addEventListener('resize', this.heroMotionScrollHandler, { passive: true });
      this.heroMotionScrollHandler();
    }

    this.syncHeroMotion();
    this.$nextTick(() => {
      const flowDots = this.$refs.flowDots;
      if (!flowDots) return;

      this.heroDotMotion = createHeroFlowDots(flowDots, this.$el);
      this.syncHeroDotPaths();
      this.syncHeroMotion();
      if (!window.ResizeObserver) return;

      this.heroDotResizeObserver = new window.ResizeObserver(() => {
        this.scheduleHeroDotPaths();
      });
      this.heroDotResizeObserver.observe(flowDots);
      // Localized labels can resize a card without changing the hero itself.
      this.$el.querySelectorAll('.hc-chip').forEach((chip) => {
        this.heroDotResizeObserver.observe(chip);
      });
    });
  },
  beforeUnmount() {
    document.removeEventListener('visibilitychange', this.handleHeroVisibilityChange);
    window.removeEventListener('pagehide', this.handleHeroPagePause);
    window.removeEventListener('pageshow', this.handleHeroPageResume);
    window.removeEventListener('drct:extension-transition', this.syncHeroMotion);
    this.heroMotionObserver?.disconnect();
    this.heroDotResizeObserver?.disconnect();
    window.removeEventListener('scroll', this.heroMotionScrollHandler);
    window.removeEventListener('resize', this.heroMotionScrollHandler);
    if (this.heroMotionScrollTimer) window.clearTimeout(this.heroMotionScrollTimer);
    if (this.heroDotResizeTimer) window.clearTimeout(this.heroDotResizeTimer);
    this.heroMotionQuery?.removeEventListener?.('change', this.handleHeroMotionPreferenceChange);
    this.heroDotMotion?.destroy();
  },
  methods: {
    handleHeroMotionPreferenceChange() {
      this.syncHeroDotPaths();
      this.syncHeroMotion();
    },
    handleHeroVisibilityChange() {
      if (document.hidden) {
        this.handleHeroPagePause();
      } else {
        this.handleHeroPageResume();
      }
    },
    handleHeroPagePause() {
      this.heroPageIsActive = false;
      this.pauseHeroMotion();
    },
    handleHeroPageResume() {
      if (document.hidden) return;
      this.heroPageIsActive = true;
      this.syncHeroMotion();
    },
    syncHeroMotion() {
      const shouldPause =
        document.hidden ||
        !this.heroPageIsActive ||
        !this.heroIsVisible ||
        this.heroMotionQuery?.matches ||
        !!document.documentElement.dataset.extensionTransition;
      if (shouldPause) {
        this.pauseHeroMotion();
        return;
      }

      this.resumeHeroMotion();
    },
    scheduleHeroDotPaths() {
      if (this.heroDotResizeTimer) window.clearTimeout(this.heroDotResizeTimer);

      this.heroDotResizeTimer = window.setTimeout(() => {
        this.heroDotResizeTimer = null;
        this.syncHeroDotPaths();
      }, 120);
    },
    syncHeroDotPaths() {
      this.heroDotMotion?.resize();
    },
    pauseHeroMotion() {
      this.heroDotMotion?.pause();
      if (this.heroMotionPaused) return;
      this.heroMotionPaused = true;
      this.$el?.classList.add('hero-motion-paused');
    },
    resumeHeroMotion() {
      this.heroDotMotion?.resume();
      if (!this.heroMotionPaused) return;
      this.$el?.classList.remove('hero-motion-paused');
      this.heroMotionPaused = false;
    },
    tryClick() {
      new AmplitudeEvent('Try', { spot: this.trackingSpot });
    },
  },
};
</script>

<style lang="scss" scoped>
.hero-split-outer {
  background: #ffffff;
  overflow: hidden;
}

.hero-centered {
  position: relative;
  min-height: 680px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 90px 0;
  contain: paint;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background-image: radial-gradient(circle, rgba(27, 39, 51, 0.11) 1px, transparent 1px);
    background-size: 28px 28px;
    pointer-events: none;
    z-index: 0;
  }
}

.hero-centered--airlines {
  --airlines-seller-offset: 50px;
}

@media (min-width: 1025px) {
  .hero-centered--iata {
    .hc-al--1,
    .hc-al--3 {
      left: max(64px, calc(50% - 640px));
    }

    .hc-al--2 {
      left: max(144px, calc(50% - 480px));
    }

    .hc-al--4,
    .hc-al--6 {
      top: auto;
      right: max(64px, calc(50% - 640px));
      bottom: auto;
      left: auto;
    }

    .hc-al--4 {
      top: 8%;
    }

    .hc-al--5 {
      top: 38%;
      right: max(144px, calc(50% - 480px));
      bottom: auto;
      left: auto;
    }

    .hc-al--6 {
      top: 65%;
    }
  }
}

// On wide home pages, keep the left airline group identical to IATA. The
// travel-seller cards continue to occupy the right side of the composition.
@media (min-width: 1280px) {
  .hero-centered:not(.hero-centered--iata) {
    .hc-al--1,
    .hc-al--3 {
      left: max(64px, calc(50% - 640px));
    }

    .hc-al--2 {
      left: max(144px, calc(50% - 480px));
    }

    .hc-al--4,
    .hc-al--5,
    .hc-al--6 {
      display: none;
    }
  }
}

// Below wide desktop, both heroes use the same symmetric airline
// constellation so the central content has room.
@media (min-width: 1025px) and (max-width: 1279px) {
  .hero-centered {
    .hc-al--1,
    .hc-al--3 {
      left: max(64px, calc(50% - 640px));
      right: auto;
      bottom: auto;
    }

    .hc-al--1 {
      top: 8%;
    }

    .hc-al--2 {
      top: 38%;
      left: max(144px, calc(50% - 480px));
      right: auto;
      bottom: auto;
    }

    .hc-al--3 {
      top: 65%;
    }

    .hc-al--4,
    .hc-al--6 {
      left: auto;
      right: max(64px, calc(50% - 640px));
      bottom: auto;
    }

    .hc-al--4 {
      top: 8%;
    }

    .hc-al--5 {
      top: 38%;
      left: auto;
      right: max(144px, calc(50% - 480px));
      bottom: auto;
    }

    .hc-al--6 {
      top: 65%;
    }
  }
}

.hc-flow-dots {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1;
}

// Tiny independent layers replace the full-hero SVG animation. Only their
// transform and opacity change; size and shadow are painted once per resize.
.hc-flow-dot {
  position: absolute;
  left: 0;
  top: 0;
  width: var(--hc-dot-size, 5px);
  height: var(--hc-dot-size, 5px);
  margin: calc(var(--hc-dot-size, 5px) / -2);
  border-radius: 50%;
  background: #2a8aea;
  box-shadow: 0 0 0 calc(var(--hc-dot-size, 5px) / 2) rgba(42, 138, 234, 0.16);
  opacity: 0;
}

@keyframes hc-float {
  0%,
  100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-8px);
  }
}

.hc-body {
  position: relative;
  z-index: 3;
  text-align: center;
  max-width: 660px;
  padding: 0 24px;

  .hero-split__ctas {
    justify-content: center;
  }
}

.hero-split__title {
  color: #1b2733;
  font-size: 44px;
  font-weight: 700;
  letter-spacing: -0.6px;
  line-height: 1.14;
  margin-top: 18px;

  @media (max-width: 1024px) {
    font-size: 36px;
  }
  @media (max-width: 767px) {
    font-size: 32px;
  }
  @media (max-width: 413px) {
    font-size: 27px;
  }
}

.hero-split__sub {
  color: #1b2733;
  font-size: 17px;
  font-weight: 600;
  line-height: 1.5;
  margin-top: 20px;
}

.hero-split__desc {
  color: rgba(27, 39, 51, 0.7);
  font-size: 15px;
  line-height: 1.65;
  margin-top: 14px;
}

.hero-split__desc-lead {
  color: #1b2733;
  font-weight: 700;
}

.hero-split__ctas {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 32px;
}

.nav-bar__demo {
  background: #2a8aea;
  border-radius: 10px;
  color: #fff !important;
  font-size: 13px;
  font-weight: bold;
  height: 38px;
  letter-spacing: 0.6px;
  line-height: 20px;
  padding: 10px 20px;
  text-transform: uppercase;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  text-decoration: none;
  transition:
    background 0.15s,
    box-shadow 0.15s;
  white-space: nowrap;

  &:hover {
    background: #1a7dd4;
    box-shadow: 0 4px 14px rgba(42, 138, 234, 0.3);
  }
}

.hc-al-wrap,
.hc-chips {
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 2;
}

// Keep the airline constellation as a single visual group, slightly lower
// than the hero content without affecting each tile's floating animation.
.hc-al-wrap {
  transform: translateY(20px);
}

.hc-al {
  position: absolute;
  width: 80px;
  height: 80px;
  animation-fill-mode: both;
  will-change: transform;

  img {
    width: 100%;
    height: auto;
    display: block;
  }

  &::before {
    content: '';
    position: absolute;
    inset: -16px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(42, 138, 234, 0.08) 0%, transparent 62%);
    pointer-events: none;
  }
}

.hc-al--1 {
  top: 8%;
  left: 2%;
  animation: hc-float 5.5s ease-in-out infinite;
}
.hc-al--2 {
  top: 38%;
  left: 9%;
  animation: hc-float 6.3s ease-in-out infinite -1.4s;
}
.hc-al--3 {
  top: 65%;
  left: 2%;
  animation: hc-float 4.9s ease-in-out infinite -0.8s;
}
.hc-al--4 {
  bottom: 8%;
  left: 17%;
  animation: hc-float 6.7s ease-in-out infinite -2.2s;
}
.hc-al--5 {
  top: 20%;
  left: 18%;
  animation: hc-float 5.2s ease-in-out infinite -1.7s;
}
.hc-al--6 {
  top: 50%;
  left: 21%;
  animation: hc-float 5.7s ease-in-out infinite -3.4s;
}

.hc-chip {
  position: absolute;
  display: flex;
  align-items: center;
  gap: 10px;
  background: rgba(255, 255, 255, 0.94);
  // Keep the card dimensions stable without the blue outline.
  border: 1px solid transparent;
  border-radius: 14px;
  padding: 10px 16px 10px 10px;
  box-shadow:
    0 2px 8px rgba(27, 39, 51, 0.06),
    0 8px 28px rgba(27, 39, 51, 0.07),
    inset 0 1px 0 rgba(255, 255, 255, 0.95);
  font-size: 13px;
  font-weight: 600;
  color: #1b2733;
  white-space: nowrap;
  letter-spacing: -0.1px;
  animation-fill-mode: both;
  will-change: transform;
}

.hero-motion-paused {
  .hc-al,
  .hc-al img,
  .hc-chip {
    animation-play-state: paused !important;
  }
}

.hc-chip__icon {
  width: 30px;
  height: 30px;
  border-radius: 9px;
  background: linear-gradient(135deg, rgba(42, 138, 234, 0.16) 0%, rgba(42, 138, 234, 0.07) 100%);
  border: 1px solid rgba(42, 138, 234, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.hc-chip--1 {
  top: 8%;
  right: 3%;
  animation: hc-float 5.8s ease-in-out infinite -0.3s;
}
.hc-chip--2 {
  top: 24%;
  right: 10%;
  animation: hc-float 6.5s ease-in-out infinite -1.9s;
}
.hc-chip--3 {
  top: 44%;
  right: 3%;
  animation: hc-float 4.7s ease-in-out infinite -1.1s;
}
.hc-chip--4 {
  top: 62%;
  right: 10%;
  animation: hc-float 6.1s ease-in-out infinite -2.8s;
}
.hc-chip--5 {
  bottom: 8%;
  right: 3%;
  animation: hc-float 5.4s ease-in-out infinite -0.6s;
}
.hc-chip--6 {
  bottom: 8%;
  right: 10%;
  animation: hc-float 5.9s ease-in-out infinite -2.1s;
}
@media (prefers-reduced-motion: reduce) {
  .hc-flow-dots {
    display: none;
  }

  .hc-al,
  .hc-al img,
  .hc-chip {
    animation: none;
    will-change: auto;
  }
}

@media (min-width: 1025px) and (max-width: 1599px) {
  .hc-body {
    max-width: min(620px, calc(100% - 500px));
    padding: 0;
  }
}

@media (min-width: 768px) and (max-width: 1024px) {
  .hc-flow-dots {
    display: none;
  }

  .hc-chips {
    display: none;
  }

  .hc-al-wrap {
    display: block;
  }

  .hc-al {
    width: 56px;
    height: 56px;
  }

  .hc-al--1 {
    top: 11%;
    left: clamp(32px, 6vw, 64px);
  }
  .hc-al--4 {
    top: 11%;
    right: clamp(32px, 6vw, 64px);
    left: auto;
    bottom: auto;
  }
  .hc-al--2 {
    top: 46%;
    left: clamp(72px, 10vw, 112px);
    right: auto;
    bottom: auto;
  }
  .hc-al--5 {
    top: 46%;
    left: auto;
    right: clamp(72px, 10vw, 112px);
    bottom: auto;
  }
  .hc-al--3 {
    top: auto;
    bottom: 12%;
    left: clamp(32px, 6vw, 64px);
  }
  .hc-al--6 {
    top: auto;
    right: clamp(32px, 6vw, 64px);
    bottom: 12%;
    left: auto;
  }

  .hc-body {
    max-width: 620px;
    padding: 0 110px;
  }
}

@media (max-width: 767px) {
  .hc-flow-dots {
    display: none;
  }

  .hc-chips {
    display: none;
  }
  .hc-al-wrap {
    display: block;
  }

  .hero-centered {
    min-height: 560px;
    padding: 64px 20px;

    &::before {
      display: block;
    }
  }

  .hc-al {
    width: 44px;
    height: 44px;

    &::before {
      inset: -10px;
    }
  }

  .hc-al--2,
  .hc-al--5 {
    display: block;
  }

  .hc-al--1 {
    top: 10%;
    left: clamp(10px, min(7vw, calc(50% - 210px)), 52px);
    right: auto;
    bottom: auto;
  }
  .hc-al--2 {
    top: 41%;
    left: clamp(20px, min(14vw, calc(50% - 210px)), 104px);
    right: auto;
    bottom: auto;
  }
  .hc-al--3 {
    top: auto;
    left: clamp(10px, min(7vw, calc(50% - 210px)), 52px);
    right: auto;
    bottom: 14%;
  }
  .hc-al--4 {
    top: 12%;
    left: auto;
    right: clamp(10px, min(7vw, calc(50% - 210px)), 52px);
    bottom: auto;
  }
  .hc-al--5 {
    top: 44%;
    left: auto;
    right: clamp(20px, min(14vw, calc(50% - 210px)), 104px);
    bottom: auto;
  }
  .hc-al--6 {
    top: auto;
    left: auto;
    right: clamp(10px, min(7vw, calc(50% - 210px)), 52px);
    bottom: 16%;
  }

  .hc-body {
    max-width: 420px;
    padding: 0 50px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .hc-al,
  .hc-chip,
  .hc-al img {
    animation: none !important;
  }
}

// On the homepage, the right side always represents travel sellers. Compact
// seller icons replace the airline column on every non-wide layout.
@media (max-width: 1279px) {
  .hero-centered:not(.hero-centered--iata) {
    .hc-chips {
      display: block;
    }

    .hc-al--4,
    .hc-al--5,
    .hc-al--6 {
      display: none;
    }

    .hc-chip {
      width: 42px;
      height: 42px;
      justify-content: center;
      padding: 5px;
      border-radius: 12px;
    }

    .hc-chip > span:last-child {
      display: none;
    }
  }
}

// Three fixed seller slots mirror the rhythm of the airline marks: the
// middle card sits inward; the upper and lower cards sit farther right.
.hero-centered--home {
  .hc-chip--1,
  .hc-chip--3 {
    right: 3%;
    bottom: auto;
  }

  .hc-chip--1 {
    top: calc(8% + 34px);
  }

  .hc-chip--2 {
    top: calc(38% + 34px);
    right: 10%;
  }

  .hc-chip--3 {
    top: calc(65% + 34px);
  }
}

@media (min-width: 1280px) {
  .hero-centered--home {
    // Reserve room for the longest translated label in the middle slot.
    --home-seller-middle-right: max(256px, calc(50% - 310px - 24px - 164px));

    .hc-body {
      max-width: min(620px, calc(100% - 888px));
    }

    .hc-chip {
      // Keep slot centers fixed even when the random labels have different widths.
      translate: 50% 0;
    }

    .hc-chip--1,
    .hc-chip--3 {
      right: calc(var(--home-seller-middle-right) - 80px);
    }

    .hc-chip--2 {
      right: var(--home-seller-middle-right);
    }
  }
}

@media (min-width: 1600px) {
  .hero-centered--home {
    --home-seller-middle-right: max(256px, calc(50% - 330px - 24px - 164px));

    .hc-body {
      max-width: 660px;
    }
  }
}

@media (max-width: 1024px) {
  .hero-centered--home {
    .hc-chip--1,
    .hc-chip--3 {
      right: clamp(10px, min(7vw, calc(50% - 210px)), 52px);
    }

    .hc-chip--1 {
      top: calc(10% + 20px);
    }

    .hc-chip--2 {
      top: calc(41% + 20px);
      right: clamp(20px, min(14vw, calc(50% - 210px)), 104px);
    }

    .hc-chip--3 {
      top: auto;
      bottom: calc(14% - 20px);
    }
  }
}

// Airlines use the same centered constellation as IATA's airline marks. Seller
// cards are shuffled across its six slots on each page load rather than pinned
// to either viewport edge.
@media (min-width: 1001px) {
  .hero-centered.hero-centered--airlines {
    // Every slot reserves the widest localized seller card, so a shuffled
    // card never overlaps the centered copy column.
    --airlines-card-max: 327px;
    --airlines-copy-gap: 24px;
    --airlines-page-gutter: 12px;
    // From 1001px to the wide desktop composition, grow the copy channel and
    // seller offsets together so full labels never intrude on the hero copy.
    --airlines-body-half: clamp(200px, calc(31.9768vw - 120.087px), 310px);
    --airlines-copy-width: clamp(400px, calc(58.1396vw - 181.977px), 600px);
    --airlines-seller-inward-shift: clamp(0px, calc(14.5349vw - 145.493px), 50px);
    --airlines-seller-middle-row-inward-shift: clamp(0px, calc(29.0698vw - 290.986px), 100px);
    --airlines-seller-inner-edge: max(
      var(--airlines-page-gutter),
      calc(50% - var(--airlines-body-half) - var(--airlines-copy-gap) - var(--airlines-card-max))
    );
    --airlines-seller-outer-edge: max(
      var(--airlines-page-gutter),
      calc(var(--airlines-seller-inner-edge) - 32px)
    );

    .hc-chip {
      width: auto;
      height: auto;
      justify-content: flex-start;
      padding: 10px 16px 10px 10px;
      border-radius: 14px;
    }

    .hc-chips {
      display: block;
    }

    .hc-chip > span:last-child {
      display: inline;
    }

    // Preserve visible copy clearance when the longest localized seller card
    // occupies either middle slot, which intentionally shifts 100px inward.
    .hc-body {
      max-width: var(--airlines-copy-width);
      padding: 0;
    }

    .hc-chip--1 {
      top: calc(8% + var(--airlines-seller-offset));
      right: calc(var(--airlines-seller-outer-edge) + var(--airlines-seller-inward-shift));
    }

    .hc-chip--2 {
      top: calc(38% + var(--airlines-seller-offset));
      right: calc(
        var(--airlines-seller-inner-edge) + var(--airlines-seller-middle-row-inward-shift)
      );
    }

    .hc-chip--3 {
      top: calc(65% + var(--airlines-seller-offset));
      right: calc(var(--airlines-seller-outer-edge) + var(--airlines-seller-inward-shift));
    }

    .hc-chip--4 {
      top: calc(38% + var(--airlines-seller-offset));
      right: auto;
      bottom: auto;
      left: calc(
        var(--airlines-seller-inner-edge) + var(--airlines-seller-middle-row-inward-shift)
      );
    }

    .hc-chip--5 {
      top: calc(65% + var(--airlines-seller-offset));
      right: auto;
      bottom: auto;
      left: calc(var(--airlines-seller-outer-edge) + var(--airlines-seller-inward-shift));
    }

    .hc-chip--6 {
      top: calc(8% + var(--airlines-seller-offset));
      right: auto;
      bottom: auto;
      left: calc(var(--airlines-seller-outer-edge) + var(--airlines-seller-inward-shift));
    }
  }
}

@media (min-width: 1600px) {
  .hero-centered.hero-centered--airlines {
    --airlines-body-half: 330px;

    .hc-body {
      max-width: 640px;
    }
  }
}

@media (max-width: 1000px) {
  .hero-centered--airlines {
    // At these widths the longest translated label cannot share a side
    // channel with the hero copy. Keep the recognizable seller icon layout
    // until full cards have enough room.
    .hc-chip {
      width: 42px;
      height: 42px;
      justify-content: center;
      padding: 5px;
      border-radius: 12px;
    }

    .hc-chip > span:last-child {
      display: none;
    }

    .hc-chip--1 {
      top: calc(10% + var(--airlines-seller-offset));
      right: clamp(10px, min(7vw, calc(50% - 210px)), 52px);
      bottom: auto;
      left: auto;
    }

    .hc-chip--2 {
      top: calc(41% + var(--airlines-seller-offset));
      right: clamp(20px, min(14vw, calc(50% - 210px)), 104px);
      bottom: auto;
      left: auto;
    }

    .hc-chip--3 {
      top: auto;
      right: clamp(10px, min(7vw, calc(50% - 210px)), 52px);
      bottom: calc(14% - var(--airlines-seller-offset));
      left: auto;
    }

    .hc-chip--4 {
      top: calc(41% + var(--airlines-seller-offset));
      right: auto;
      bottom: auto;
      left: clamp(20px, min(14vw, calc(50% - 210px)), 104px);
    }

    .hc-chip--5 {
      top: auto;
      right: auto;
      bottom: calc(14% - var(--airlines-seller-offset));
      left: clamp(10px, min(7vw, calc(50% - 210px)), 52px);
    }

    .hc-chip--6 {
      top: calc(10% + var(--airlines-seller-offset));
      right: auto;
      bottom: auto;
      left: clamp(10px, min(7vw, calc(50% - 210px)), 52px);
    }
  }
}
</style>
